import React from "react";
import { Card } from "reactstrap";
import { Button, Tag } from "antd";
import { InfoWindow } from "react-google-maps";

export class VisitMarker extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { marker, index } = this.props;
    return (
      <InfoWindow onCloseClick={() => this.props.handleOpenMarker(index)}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "start",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 8,
              padding: "16px 20px",
            }}
          >
            <h6 style={{ margin: 0 }}>{marker.title}</h6>
            <div style={{ display: "flex", gap: 8 }}>
              <Tag color={marker.visit_status.statusColor}>
                {marker.visit_status.name}
              </Tag>
              {marker.finish_reason && (
                <Tag color={marker.finish_reason.finishColor}>
                  {marker.finish_reason.name}
                </Tag>
              )}
            </div>
          </div>
          <p
            style={{
              width: "90%",
            }}
          >
            {marker.visit_type}
          </p>
          <p
            style={{
              width: "90%",
            }}
          >{`${marker.visit_address}, ${marker.visit_locality}`}</p>
          <div
            style={{
              width: "90%",
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
              gap: 8,
            }}
          >
            <span
              dangerouslySetInnerHTML={{
                __html: marker.visit_date_day,
              }}
            ></span>
            <span
              dangerouslySetInnerHTML={{
                __html: marker.visit_date_hour,
              }}
            ></span>
          </div>
          <div style={{ padding: "8px 0px" }}>
            {marker.technician.map((technician) => (
              <Tag bordered={false} color="purple">
                {technician.username}
              </Tag>
            ))}
          </div>

          <Button
            type="link"
            onClick={() => this.props.handleRedirect(marker.id)}
            style={{ paddingTop: 8 }}
          >
            Ir al detalle
          </Button>
        </div>
      </InfoWindow>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/HomeVisits/components/VisitMarker.jsx